export default {"src":"https://static.finncdn.no/_c/travel/pp-web/_next/static/media/ps.58b5156b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};